import { notEmpty } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";
import { useMemo } from "react";
import { graphql, useFragment } from "react-relay";

import type { articleLeftHandSideWidgetsContent$key } from "~/queries/__generated__/articleLeftHandSideWidgetsContent.graphql";

import { SeriesWidget } from "./series-widget";
import type { Props as TopPicksWidgetProps } from "./top-picks-widget";
import { TopPicksWidget } from "./top-picks-widget";

export type Props = {
  className?: string;
  reference: articleLeftHandSideWidgetsContent$key;
  topPicksWidgetProps: Omit<TopPicksWidgetProps, "className" | "reference">;
};

export const ArticleLeftHandSideWidgets: FunctionComponent<Props> = ({
  className,
  reference: reference_,
  topPicksWidgetProps,
}) => {
  const content = useFragment(
    graphql`
      fragment articleLeftHandSideWidgetsContent on Article {
        ...seriesWidgetContent
        ...topPicksWidgetContent
        seriesContainer {
          series {
            __typename
          }
        }
      }
    `,
    reference_,
  );

  const hasSeries = useMemo(
    () => notEmpty(content.seriesContainer?.series),
    [content.seriesContainer?.series],
  );

  return hasSeries ? (
    <SeriesWidget className={className} reference={content} />
  ) : (
    <TopPicksWidget className={className} {...topPicksWidgetProps} reference={content} />
  );
};

ArticleLeftHandSideWidgets.displayName = "ArticleLeftHandSideWidgets";
